/**
 * Configuration constants for conversation sync and pagination
 */

// Maximum number of conversations to sync during background sync
export const MAX_SYNC_CONVERSATIONS = 100;
// Number of conversations to fetch per page for infinite scroll
export const CONVERSATIONS_PAGE_SIZE = 50;

export const FEATURE_DISCOVERED_WORKFLOWS_KEY = "feature_discovered_workflows";
